import { Component } from '@angular/core';
import {AsyncPipe, NgIf} from "@angular/common";
import {BackButtonComponent} from "../../components/ui/back-button/back-button.component";
import {ButtonComponent} from "../../components/ui/button/button.component";
import {ActivatedRoute, Router, RouterOutlet} from "@angular/router";
import {TabComponent} from "../../components/ui/tab/tab.component";
import {TabsComponent} from "../../components/ui/tabs/tabs.component";
import {TitleComponent} from "../../components/ui/title/title.component";
import {TranslateModule} from "@ngx-translate/core";
import {firstValueFrom, map} from "rxjs";
import {ModalService} from "../../services/modal.service";
import {TagService} from "../../services/tag.service";
import {DeleteConfirmModalComponent} from "../../components/modals/delete-confirm-modal/delete-confirm-modal.component";
import {EditTagModalComponent} from "../../components/modals/edit-tag-modal/edit-tag-modal.component";

@Component({
  selector: 'app-tag-detail',
  standalone: true,
    imports: [
        AsyncPipe,
        BackButtonComponent,
        ButtonComponent,
        NgIf,
        RouterOutlet,
        TabComponent,
        TabsComponent,
        TitleComponent,
        TranslateModule
    ],
  templateUrl: './tag-detail.component.html',
  styleUrl: './tag-detail.component.scss'
})
export class TagDetailComponent {
  tag$ = this.route.data.pipe(map(data => data['tag']));

  constructor(private modalService: ModalService, private route: ActivatedRoute, private router: Router, private tagService: TagService) {
  }

  async deleteTag() {
    const tag = await firstValueFrom(this.tag$);
    this.modalService.open(DeleteConfirmModalComponent, {
      data: {
        type: 'page.tag-detail.delete-tag.entity',
        name: tag.name,
        confirm: async () => {
          await firstValueFrom(this.tagService.delete(tag));
          this.router.navigate(['panel', 'tags']);
        },
      }
    });
  }

  async editTag() {
    this.modalService.open(EditTagModalComponent, {
      data: {
        tag: await firstValueFrom(this.tag$),
      }
    });
  }
}
